import React from 'react';
import LandingPageStep from "./LandingPageStep";
import LandingPageLayout from "../layout/LandingPageLayout";

const LandingPageThreeSteps = () => {
    return (
        <LandingPageLayout classAdd='offers-landing-page-three-steps'>
            <div className="offers-landing-page-three-steps__content">
                <div className="offers-landing-page-three-steps__title">
                    {/* TODO - Refatorar para usar HOC Media*/}
                    <div className="offers-landing-page-three-steps__title--mobile">
                        <div>
                            <hr/>
                            <p>3 passos para você</p>
                            <hr/>
                        </div>
                        <strong>ganhar dinheiro com milhas</strong>
                    </div>

                    <div className="offers-landing-page-three-steps__title--desktop">
                        <div className="offers-landing-page-three-steps__title--desktop--number">
                            3
                        </div>
                        <div className="offers-landing-page-three-steps__title--desktop--text">
                            PASSOS PARA VOCÊ GANHAR DINHEIRO COM MILHAS
                        </div>
                    </div>
                </div>
                <div className="offers-landing-page-three-steps__steps">
                    <LandingPageStep
                        stepNumber={1}
                        strongText="Veja se você já tem pontos"
                        text="no cartão de crédito."
                    />
                    <LandingPageStep
                        stepNumber={2}
                        strongText="Transfira seus pontos"
                        text="do cartão para um programa de fidelidade."
                    />
                    <LandingPageStep
                        stepNumber={3}
                        strongText="Venda suas milhas"
                        text="com facilidade e total segurança na MaxMilhas."
                    />
                </div>
            </div>
        </LandingPageLayout>
    );
};

export default LandingPageThreeSteps;